import React from 'react';
import PropTypes from 'prop-types';

const BooleanFlagRenderer = ({ value }) => value
  ? <span>Y</span>
  : <span>N</span>;

BooleanFlagRenderer.propTypes = {
  value: PropTypes.bool.isRequired,
};

export default BooleanFlagRenderer;
